import store from "../redux/store";
import { EMPTY_ACCESS } from "./accessData";

/**
 * Logged-in admin access from Redux `state.userPermission.accessData`.
 * Populated by GET /data on App bootstrap.
 */
export const getCurrentAccess = () =>
  store.getState()?.userPermission?.accessData || EMPTY_ACCESS;
